import { Component } from "@angular/core";

/**
 * Displays a guidance callout with a guidance icon and projected text content.
 * Use CSS classes on the host for spacing.
 *
 * @example
 * ```html
 * <rs-guidance-box class="mb-4" i18n>
 *   Guidance: Please ensure to populate EF_DIR with the content of an
 *   intended application or applications for your eSIM profile.
 * </rs-guidance-box>
 * ```
 */
@Component({
  selector: "rs-guidance-box",
  templateUrl: "./guidance-box.component.html",
  styles: `
    :host {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
    }
  `,
  standalone: true
}) // eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class GuidanceBoxComponent {}
